var _circle, _path, _path2, _rect, _path3, _path4, _line, _line2, _line3, _line4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#238E28",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3555 30.3966V26.1031L34.9415 23.5986H20.6988L17.6415 26.1031V30.3966",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8365 27.6774L34.8516 23.5986H20.236L22.1298 27.6774H32.8365Z",
    stroke: "#238E28",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 18.6385,
    height: 5.17862,
    rx: 2.58931,
    transform: "matrix(-1 0 0 1 36.0156 16.8008)",
    stroke: "#238E28",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7109 19.0498C45.2632 19.0498 45.7109 19.4975 45.7109 20.0498C45.7109 20.6021 45.2632 21.0498 44.7109 21.0498V19.0498ZM38.5928 21.0498H37.5928V19.0498H38.5928V21.0498ZM44.7109 21.0498H38.5928V19.0498H44.7109V21.0498Z",
    fill: "#238E28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 19.0498H18.3125V21.0498H17.3125V19.0498ZM11.1944 21.0498C10.6421 21.0498 10.1944 20.6021 10.1944 20.0498C10.1944 19.4975 10.6421 19.0498 11.1944 19.0498V21.0498ZM17.3125 21.0498H11.1944V19.0498H17.3125V21.0498Z",
    fill: "#238E28"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 1.69198,
    y2: -1,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 42.5547 17.4805)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 1.69198,
    y2: -1,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 14.2188 17.4805)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 3.07876,
    y2: -1,
    transform: "matrix(-1 0 0 1 43.6953 17.4805)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 3.07876,
    y2: -1,
    transform: "matrix(-1 0 0 1 15.6055 17.4805)",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5586 30.2607L27.5586 32.0554",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5586 33.8496L27.5586 35.6443",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5586 37.4395L27.5586 39.2341",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3555 30.2627L23.738 31.9478",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1172 33.6328L22.4997 35.3179",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8828 37.0029L21.2653 38.688",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1289 30.2607L31.7464 31.9458",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3672 33.6309L32.9847 35.3159",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6016 37.001L34.2191 38.686",
    stroke: "#238E28",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDGreen);
export default __webpack_public_path__ + "static/media/dGreen.664e70967e8407f77c964fef54dfb662.svg";
export { ForwardRef as ReactComponent };